import { FormlyFieldConfig } from '@ngx-formly/core';
import { IUpsertSoftDeletableLookupRequest } from '../requests';
import { UpsertLookupModel } from './upsert-lookup.model';
import { UpsertSoftDeletableModel } from './upsert-soft-deletable.model';

export class UpsertSoftDeletableLookupModel extends UpsertLookupModel implements IUpsertSoftDeletableLookupRequest {
  constructor(request: IUpsertSoftDeletableLookupRequest) {
    super(request);
    this.isActive = request.isActive;
  }

  static override create(data: IUpsertSoftDeletableLookupRequest): UpsertSoftDeletableLookupModel {
    return new UpsertSoftDeletableLookupModel(data);
  }

  static override createDefault(): UpsertSoftDeletableLookupModel {
    return UpsertSoftDeletableLookupModel.create({
      ...UpsertLookupModel.createDefault(),
      ...UpsertSoftDeletableModel.createDefault()
    });
  }

  override getFormlyConfig(): FormlyFieldConfig[] {
    return [...super.getFormlyConfig(), ...UpsertSoftDeletableModel.createDefault().getFormlyConfig()];
  }
}
